<script setup lang="ts">
import { vesselActualDateFormatter, vesselActualTimeFormatter, vesselTimeDifferentiate } from "@/utils/date_formatter";
import { useGlobalStore } from "@/store/global";

const globalStore = useGlobalStore();
const props = defineProps({
  id: {
    type: String,
    required: true,
    default: ""
  },
  actual: {
    type: String,
    required: true,
    default: ""
  },
  estimated: {
    type: String,
    required: true,
    default: ""
  },
  showETA: {
    type: Boolean,
    required: false,
    default: false
  },
  showNo: {
    type: Boolean,
    required: false,
    default: false
  },
  hideTime: {
    type: Boolean,
    required: false,
    default: false
  }
});

const labels = {
  no: globalStore.sitecoreData.common.no
};
</script>

<template>
  <div :slot="id" class="time-container">
    <div class="date-time-container">
      <div v-if="props.actual === '' && props.estimated === ''">
        <span v-if="props.showNo">{{ props.showNo ? labels.no : "" }}</span>
      </div>
      <div v-else>
        <div class="vessel-time">
          <strong v-if="showETA">{{ vesselTimeDifferentiate(props.actual, props.estimated) }} {{ " " }}</strong>
          <span>{{ vesselActualDateFormatter(props.actual, props.estimated) }}</span>
        </div>
        <div v-if="!props.hideTime" class="vessel-date">
          {{ vesselActualTimeFormatter(props.actual, props.estimated) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.vessel-date {
  font-weight: bold;
}
</style>
